import React, { useEffect, useState } from "react";
import api from "../../api/api";
import Spinner from "./Spinner";

export default function MaintenanceBlocker({ children }) {
  const [checking, setChecking] = useState(true);
  const [isDown, setIsDown] = useState(false);
  const [error, setError] = useState(null);

  const fetchSettings = async () => {
    setChecking(true);
    setError(null);
    try {
      // Ajuste este path se seu backend usar outro (ex: '/settings' ou '/global-config')
      const res = await api.get("/global/settings");
      // res.data pode variar; adaptamos para common shape
      const settings = res.data?.settings || res.data || {};
      // aceitar várias formas: { maintenance: true } ou { settings: { maintenance: true } }
      const maintenance = settings.maintenance === true || settings.maintenance === "1" || settings.maintenance === 1;
      setIsDown(Boolean(maintenance));
    } catch (err) {
      console.error("Erro ao verificar manutenção:", err);
      setError(err);
      // fallback: não bloquear todo o site automaticamente — apenas informar
      setIsDown(false);
    } finally {
      setChecking(false);
    }
  };

  useEffect(() => {
    fetchSettings();
    // opcional: atualizar de x em x minutos -> setInterval
  }, []);

  if (checking) {
    return (
      <div className="flex items-center justify-center h-screen">
        <Spinner />
      </div>
    );
  }

  // Se houve erro na chamada, mostramos a mensagem no topo e deixamos o site acessível
  if (error) {
    return (
      <div>
        <div className="bg-yellow-50 border-l-4 border-yellow-400 text-yellow-700 p-4 mb-4">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <span>⚠</span>
              <div>
                <div className="font-semibold">Não foi possível carregar os dados principais do site.</div>
                <div className="text-sm">Verifique o backend (/global/settings). Clique em Recarregar para tentar novamente.</div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button onClick={fetchSettings} className="px-3 py-1 bg-indigo-600 text-white rounded">Recarregar</button>
            </div>
          </div>
        </div>

        {/* Rendera o site mesmo com erro para não deixar em branco */}
        {children}
      </div>
    );
  }

  // Se modo manutenção ativo -> bloqueia tudo (padrão)
  if (isDown) {
    return (
      <div className="flex flex-col items-center justify-center h-screen bg-gray-50 text-center p-6">
        <h1 className="text-4xl font-bold text-red-600 mb-4">🚧 Site em manutenção</h1>
        <p className="text-lg text-gray-700 max-w-xl">Estamos realizando melhorias. Volte em breve.</p>
      </div>
    );
  }

  // Normal
  return children;
}
